<template>
  <div class="search__page">
    <div class="search text-center">
      <div class="row justify-center">
        <q-space />
        <div class="column text-center">
          <span class="search__title">Olá, {{ user | lowerCase }}</span>
          <span style="color: #fff; margin-left: 60px" class>
            <span class="text-weight-bold">{{ userAgencyCode }}</span> -
            <span class="text-capitalize text-weight-bold">{{ userAgencyName | lowerCaseStation }}</span>
          </span>
        </div>
        <q-space />
        <q-btn flat dense color="white" @click="$router.push({ path: '/logout' })">
          <q-icon name="power_settings_new" size="md" class="q-mr-sm" />
        </q-btn>
      </div>
      <div class="absolute-center full-width">
        <div v-if="schedulesOpens === null || schedulesOpens.message === 'Não existe embarque em aberto.'" class="search__img-buss">
          <img contain alt="Logo" src="@/assets/img/arrow_impetus_white.png" />
          <div style="color: #fff; font-weight: 600; line-height: 1.3" class="q-pt-xl">
            <span>
              INICIE UM NOVO PROCESSO DE
              <br />EMBARQUE OU DESEMBARQUE
            </span>
          </div>
        </div>
        <div v-else>
          <h1 class="text-center search__descript_pendent q-py-md">Viagens com embarque em aberto</h1>
          <div class="column items-center q-pb-lg" style="font-size: 12px">
            <div class="row" style="width: 96%">
              <div class="q-px-sm q-py-xs" style="background: #ffffff; border-radius: 10px 10px 0 0; z-index: 1">
                <q-icon name="directions_bus" style="font-size: 1.2em" />
                <span class="text-caption q-pl-xs" style="color: #172c20">
                  CARRO
                  <span class="text-weight-bold">{{ schedulesOpens.number_bus }}</span>
                </span>
              </div>
              <q-space></q-space>
              <div class="q-py-xs" style="color: #fff; border-radius: 0 10px 0 0; position: relative; left: -10px">
                <span class="text-caption text-weight-bold q-pl-sm">Embarque em andamento</span>
                <q-icon name="watch_later" style="font-size: 1.4em" class="q-pl-xs" />
              </div>
            </div>
            <div style="width: 96%; heigth: 40px; background: white; border-radius: 0 10px 10px 10px">
              <div class="row text-left q-py-sm q-px-md">
                <span class="text-subtitle2 text-weight-bold">{{ cityToCamelCase(schedulesOpens.origin) }}</span>
                <q-icon name="arrow_forward" class="q-mx-sm" style="color: #3BA46A; font-size: 1.5em" />
                <span class="text-subtitle2 text-weight-bold">{{ cityToCamelCase(schedulesOpens.destiny) }}</span>
              </div>
              <q-separator></q-separator>
              <div class="row text-left q-pl-md q-pt-sm q-pb-sm">
                <div class="column" style="font-size: 10px">
                  <span style="color: #7a8583">
                    Saída dia
                    <span class="text-weight-bold">{{ schedulesOpens.departure_travel | formatDate }}</span>
                  </span>
                  <span style="color: #7a8583">
                    Saída da agência
                    <span class="text-weight-bold">{{ schedulesOpens.departure | formatDate }}</span>
                  </span>
                  <span style="color: #7a8583">
                    Saída da agência
                    <span class="text-weight-bold">{{ schedulesOpens.alternative_agency }}</span>
                  </span>
                </div>
                <q-space></q-space>
                <div class="q-pr-md">
                  <q-btn
                    @click="goToPassengers(schedulesOpens)"
                    no-caps
                    unelevated
                    label="Continuar"
                    class="no-shadow text-weight-bold"
                    text-color="white"
                    style="background-color: #3BA46A; border-radius: 6px"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <q-page-sticky position="bottom" :offset="[30, 30]" class="hidden">
        <q-btn
          :disable="true"
          :loading="loading"
          icon-right="check_circle"
          label="Registros sincronizados"
          color="grey-10"
          style="width: 230px"
          unelevated
          no-caps
          rounded
          class="text-weight-bold"
        >
          <template v-slot:loading>
            <q-spinner-tail class="on-left" />
            Sincronizando {{ syncCount }} registros
          </template>
        </q-btn>
      </q-page-sticky>
    </div>

    <q-dialog v-model="dialogInput" seamless :maximized="false" position="bottom" transition-show="jump-up" transition-hide="jump-down">
      <q-card v-if="!userMotorist" class="search__box no-box-shadow" style="margin: 0 15px 100px 15px; padding: 70px 20px 20px 20px">
        <div class="row items-center q-pb-xl">
          <i class="ri-arrow-up-circle-line q-pr-sm" style="font-size: 30px; color: #808285"></i>
          <span class="search__descript">
            REALIZE O EMBARQUE DE
            <br />PASSAGEIROS
          </span>
        </div>

        <div>
          <span style="color: #808285; font-size: 13px">Digite a cidade de origem</span>
          <sectional label="Ex.: Ji-Paraná-RO" :value.sync="origin" @update="(value) => (origin = value)" :disable="userMotorist === 1 ? false : true" />
        </div>

        <div>
          <span style="color: #808285; font-size: 13px">Digite a cidade de destino</span>
          <sectional label="Ex.: Porto Velho-RO" :value.sync="destiny" @update="(value) => (destiny = value)" />
        </div>

        <div>
          <span style="color: #808285; font-size: 13px">Data da viagem</span>
          <q-input @click="toggleDate" filled input-class="departure-date" v-model="date" label="Data viagem" readonly>
            <template v-slot:prepend>
              <q-icon class="cursor-pointer" left name="event">
                <q-popup-proxy ref="date" transition-hide="scale" transition-show="scale">
                  <q-date v-model="date" today-btn mask="DD/MM/YYYY" @input="toggleDate" :options="optionsDate" />
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>

        <div class="row justify-center q-py-md">
          <q-btn
            :disable="origin === null || destiny === null"
            @click="search"
            unelevated
            no-caps
            label="Pesquisar viagem"
            type="submit"
            size="md"
            class="full-width text-weight-bold q-py-md"
            text-color="white"
            style="font-size: 13px; background-color: #3BA46A"
          />
        </div>
      </q-card>
      <q-card v-else class="search__box no-box-shadow" style="margin: 0 15px 100px 15px; padding: 70px 20px 20px 20px">
        <div class="row items-center q-pb-xl">
          <i class="ri-arrow-up-circle-line q-pr-sm" style="font-size: 30px; color: #808285"></i>
          <span class="search__descript">
            SELECIONE A SUA VIAGEM
            <br />PARA INICIAR O EMBARQUE
          </span>
        </div>
        <q-list v-for="(travel, index) in motoristTravels" :key="index">
          <q-item class="q-px-none">
            <q-item-section>
              <q-item-label class="text-weight-bold" v-html="travel.travel_description" />
              <q-item-label class="text-weight-bold" caption>Data: {{ travel.departure_date | date }} ás {{ travel.departure_time | time }}</q-item-label>
              <q-item-label class="text-weight-bold" caption>Veiculo: {{ travel.number_bus }}</q-item-label>
              <q-item-label class="text-weight-bold" caption>Origem: {{ travel.origin }}</q-item-label>
              <q-item-label class="text-weight-bold" caption>Destino: {{ travel.destiny }}</q-item-label>
            </q-item-section>
            <q-item-section class="q-pl-none" avatar>
              <q-btn
                @click="searchBoardingsMotorist(travel)"
                unelevated
                no-caps
                label="Selecionar"
                class="text-weight-bold q-py-md"
                text-color="white"
                style="font-size: 13px; background-color: #3BA46A"
              />
            </q-item-section>
          </q-item>
          <q-separator v-show="motoristTravels.length !== index + 1"></q-separator>
        </q-list>
      </q-card>
    </q-dialog>

    <q-dialog v-model="dialogQrCode" seamless :maximized="false" position="bottom" transition-show="jump-up" transition-hide="jump-down">
      <q-card class="search__box no-box-shadow" style="margin: 0 15px 100px 15px">
        <div class="row items-center">
          <span class="search__descript">
            Procurar ticket
            <br />de bagagem
          </span>
        </div>
        <div class="q-pt-md">
          <q-btn @click="readQRCodeLuggage()" unelevated no-caps style="background: #3BA46A" class="full-width q-py-md text-white">
            <i class="ri-qr-code-line q-pr-sm" style="font-size: 25px"></i>
            <span class="text-weight-bold">Ler QR Code da bagagem</span>
          </q-btn>
        </div>
        <div class="q-pt-md">
          <span style="color: #808285; font-weight: 600; font-size: 16px">PESQUISAR POR CÓDIGO</span>
          <div class="qrcode__grid q-pt-md">
            <div>
              <span style="color: #808285">Empresa</span>
              <q-input filled v-model="searchLuggage.company" placeholder="00000" mask="#####" @blur="formatCompany()" />
            </div>
            <div>
              <span style="color: #808285">Modelo</span>
              <q-input filled v-model="searchLuggage.model" placeholder="00" />
            </div>
            <div>
              <span style="color: #808285">Série</span>
              <q-input filled v-model="searchLuggage.serie" placeholder="0000" />
            </div>
            <div>
              <span style="color: #808285">Número</span>
              <q-input filled v-model="searchLuggage.number" placeholder="00000000" />
            </div>
          </div>
          <div class="q-pt-lg">
            <q-btn
              :disable="validInputSearchLuggage()"
              @click="searchTicketDetails()"
              outline
              color="grey-10"
              no-caps
              label="Pesquisar"
              class="full-width q-py-sm text-weight-bold"
              style="font-size: 16px"
            />
          </div>
        </div>
      </q-card>
    </q-dialog>

    <q-footer class="footer row justify-between q-px-sm q-py-sm">
      <q-btn @click="(buttonActive = ''), (dialogInput = false), (dialogQrCode = false)" flat dense no-caps replace class="button">
        <div class="column items-center" :class="buttonActive === '' ? 'actived' : ''">
          <i class="ri-home-smile-2-line" style="font-size: 20px"></i>
          <label>Inicio</label>
        </div>
      </q-btn>
      <q-btn @click="(buttonActive = 'boarding'), (dialogInput = true), (dialogQrCode = false)" flat dense no-caps replace class="button">
        <div class="column items-center" :class="buttonActive === 'boarding' ? 'actived' : ''">
          <i class="ri-arrow-up-circle-line" style="font-size: 20px"></i>
          <label>Embarque</label>
        </div>
      </q-btn>
      <q-btn to="/disembark-passengers" flat dense no-caps replace class="button">
        <div class="column items-center" :class="buttonActive === 'landing' ? 'actived' : ''">
          <i class="ri-arrow-down-circle-fill" style="font-size: 20px"></i>
          <label>Desembarque</label>
        </div>
      </q-btn>
      <q-btn @click="(buttonActive = 'readTicket'), (dialogInput = false), (dialogQrCode = true)" flat dense no-caps replace class="button">
        <div class="column items-center" :class="buttonActive === 'readTicket' ? 'actived' : ''">
          <i class="ri-qr-code-line" style="font-size: 20px"></i>
          <label>Ler ticket</label>
        </div>
      </q-btn>
      <q-btn to="/history-travel" flat dense no-caps replace class="button">
        <div class="column items-center" :class="buttonActive === 'history' ? 'actived' : ''">
          <i class="ri-history-line" style="font-size: 20px"></i>
          <label>Histórico</label>
        </div>
      </q-btn>
    </q-footer>
  </div>
</template>

<script>
import * as carbon from "carbonjs";

import { DATA_HORARIOS, USER, USER_AGENCY, USER_AGENCY_CODE, USER_AGENCY_NAME, USER_MOTORIST, DISEMBARK_OFFLINE, DISEMBARK_LIST } from "../variables";
import { mutations, store } from "../store";

import { formatDate, setSessionStorage, cityToCamelCase, getLocalStorage, sync, dateBRtoEUA, vaiParaUrl, getHost } from "../functions";
import Sectional from "../components/Sectional.vue";

export default {
  components: {
    Sectional,
  },

  filters: {
    formatDate,

    lowerCase(name) {
      if (name) {
        return name.toLowerCase();
      }

      return name;
    },
    lowerCaseStation(station) {
      if (!station) {
        return station;
      }

      const indexLastHyphen = station.lastIndexOf("-");
      const city = station.substr(0, indexLastHyphen).toLowerCase();
      const state = station.substr(indexLastHyphen);

      return `${city}${state}`;
    },
    date(d) {
      return d.split("T")[0].split("-").reverse().join("/");
    },
    time(t) {
      return t.slice(0, 5);
    },
  },

  data() {
    return {
      disembarkListValidation: null,
      dialogInput: false,
      dialogQrCode: false,
      searchLuggage: {
        company: "",
        model: "",
        serie: "",
        number: "",
      },
      buttonActive: "",
      user: "",
      userAgency: "",
      userAgencyCode: "",
      userAgencyName: "",
      userMotorist: 0,
      optionsDate: [
        carbon.parse(new Date().setDate(new Date().getDate() + 1)).format("YYYY/MM/DD"),
        carbon.parse(new Date()).format("YYYY/MM/DD"),
        carbon.parse(new Date().setDate(new Date().getDate() - 1)).format("YYYY/MM/DD"),
      ],
      schedulesOpens: null,
      sections: [],
      motoristTravels: [],
      motoristSelectedTravel: null,
    };
  },

  computed: {
    origin: {
      get() {
        return store.origin;
      },
      set(value) {
        mutations.setOrigin(value);
      },
    },

    destiny: {
      get() {
        return store.destiny;
      },
      set(value) {
        mutations.setDestiny(value);
      },
    },

    date: {
      get() {
        return store.date;
      },
      set(value) {
        mutations.setDate(value);
      },
    },

    schedules: {
      get() {
        return store.schedules;
      },
      set(value) {
        mutations.setSchedules(value);
      },
    },

    motoristTravel: {
      get() {
        return store.motoristTravel;
      },
      set(value) {
        mutations.setMotoristTravel(value);
      },
    },

    isSmallWidth() {
      return window.innerWidth <= 320;
    },
    loading: {
      get() {
        if (getLocalStorage(DISEMBARK_OFFLINE)) {
          if (getLocalStorage(DISEMBARK_OFFLINE).length > 0) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      },
    },
    syncCount: {
      get() {
        if (getLocalStorage(DISEMBARK_OFFLINE)) {
          return getLocalStorage(DISEMBARK_OFFLINE).length;
        }
        return 0;
      },
    },
    disembarkList: {
      get() {
        if (this.disembarkListValidation) {
          return false;
        }
        return true;
      },
    },
  },

  created() {
    this.date = carbon.parse(new Date()).format("DD/MM/YYYY");
    window.http.get(`${getHost()}/eucaturmobile/sections`).then((r) => {
      setSessionStorage("sections", r.data);
    });
  },

  mounted() {
    this.user = getLocalStorage(USER).split(" ")[0];
    this.userAgency = getLocalStorage(USER_AGENCY);
    this.userAgencyCode = getLocalStorage(USER_AGENCY_CODE);
    this.userAgencyName = getLocalStorage(USER_AGENCY_NAME);
    this.userMotorist = getLocalStorage(USER_MOTORIST);
    this.getSchedulesOpens();
    if (!this.userMotorist) {
      this.searchSections();
    }
    this.searchMotoristTravels();
    this.disembarkListValidation = getLocalStorage(DISEMBARK_LIST);
  },

  methods: {
    cityToCamelCase,
    sync,
    formatCompany() {
      if(this.searchLuggage.company.length === 1) this.searchLuggage.company = '0000'+this.searchLuggage.company;
      if(this.searchLuggage.company.length === 2) this.searchLuggage.company = '000'+this.searchLuggage.company;
      if(this.searchLuggage.company.length === 3) this.searchLuggage.company = '00'+this.searchLuggage.company;
      if(this.searchLuggage.company.length === 4) this.searchLuggage.company = '0'+this.searchLuggage.company;
    },

    search() {
      setSessionStorage(DATA_HORARIOS, this.date);
      mutations.setSchedules([]);

      const uri = `${getHost()}/schedules?origin=${this.origin.code}&destiny=${this.destiny.code}&date=${dateBRtoEUA(this.date)}`;
      window.http.get(uri).then((r) => {
        this.schedules = r.data;
        vaiParaUrl("/horarios");
      });
    },

    searchBoardingsMotorist(travel) {
      mutations.setSchedules([]);

      let params = {
        travel_id: travel.travel_id,
      };

      this.motoristTravel = params;

      window.http.get(`${getHost()}/eucaturmobile/list-motorist-boarding`, params).then((r) => {
        this.schedules = r.data;
        vaiParaUrl("/horarios");
      });
    },

    toggleDate() {
      this.$refs.date.toggle();
    },

    passengers(travel) {
      mutations.setTravel(travel);
      vaiParaUrl("/qr-code");
    },

    getSchedulesOpens() {
      window.http.get(`${getHost()}/eucaturmobile/boarding`).then((r) => {
        this.schedulesOpens = r.data;
      });
    },

    goToPassengers(travel) {
      mutations.openAlert({
        open: true,
        message: "Embarque em andamento.",
        status: 200,
      });
      mutations.setTravel(travel);
      mutations.setSelectedSchedule(travel);
      vaiParaUrl("/horarios");
    },

    searchSections() {
      window.http.get(`${getHost()}/eucaturmobile/sections`).then((r) => {
        this.origin = r.data.filter((v) => v.description === this.userAgencyName)[0];
      });
    },

    searchTicketDetails() {
      window.http
        .get(`${getHost()}/eucaturmobile/luggage`, this.searchLuggage)
        .then((r) => {
          mutations.setTicketDetails(r.data);
          vaiParaUrl("/detalhes-passagem");
        })
        .catch(() => {
          mutations.openAlert({
            open: true,
            message: "Não existe registro",
            status: 400,
          });
        });
    },

    validInputSearchLuggage() {
      if (!this.searchLuggage.company) return true;
      if (!this.searchLuggage.model) return true;
      if (!this.searchLuggage.serie) return true;
      if (!this.searchLuggage.number) return true;
    },

    readQRCodeLuggage() {
      if (this.$q.platform.is.cordova) {
        window.cordova.plugins.barcodeScanner.scan(
          async (result) => {
            let data = JSON.parse(result);

            if (!result) {
              mutations.openAlert({
                open: true,
                message: "Erro na Leitura",
                status: 500,
              });
              return;
            }

            let number = data.numero;
            let serie = data.serie;
            let model = data.modelo;
            let company = data.empresa;

            let params = {
              company,
              model,
              serie,
              number,
            };

            this.searchLuggage = params;

            this.searchTicketDetails();
          },
          (error) => {
            mutations.openAlert({
              open: true,
              message: error,
              status: 500,
            });
          },
          {
            preferFrontCamera: false, // iOS and Android
            showFlipCameraButton: false, // iOS and Android
            showTorchButton: true, // iOS and Android
            torchOn: false, // Android, launch with the torch switched on (if available)
            saveHistory: true, // Android, save scan history (default false)
            prompt: "Leitura de QrCode", // Android
            resultDisplayDuration: 1500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
            formats: "QR_CODE", // default: all but PDF_417 and RSS_EXPANDED
            orientation: "portrait", // Android only (portrait|landscape), default unset so it rotates with the device
            disableAnimations: true, // iOS
            disableSuccessBeep: true, // iOS and Android
          }
        );
      }
    },

    searchMotoristTravels() {
      if (this.userMotorist) {
        window.http.get(`${getHost()}/eucaturmobile/motorist-travels`).then((r) => {
          this.motoristTravels = r.data;
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import '../scss/variables';

.search__page {
  display: grid;
  grid-template-rows: 1fr;
}

.search {
  background-color: $color-green-dark;
  height: calc(100vh - 70px);
  padding: 1rem;
}

.search__img-buss {
  img {
    width: 269px;
    filter: drop-shadow(-12px 23px 32px rgba(0, 0, 0, 0.5));
  }
}

.search__title {
  color: #fff;
  font-weight: 600;
  font-size: 15px;
  text-transform: capitalize;
  margin-left: 60px;
}

.search__descript {
  color: $color-green-dark;
  font-weight: 600;
  font-size: 14px;
  line-height: normal;
  text-transform: uppercase;
}

.search__descript_pendent {
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  line-height: normal;
}

.search__btn {
  padding: 2px;
  font-size: 14px;
  font-weight: 600;

  width: 190px;
  justify-self: center;
}

.search__box {
  display: grid;
  grid-row-gap: 10px;
  grid-template-rows: 30px repeat(3, max-content);

  align-items: center;
  padding: 20px 5%;
  width: 100%;
  border-radius: 10px !important;
}

.search__label {
  font-size: 12px;
  color: #7a8583;
  font-weight: 400;
}

.departure-date {
  font-weight: 500;
}

.footer {
  background: white;
  .button {
    font-size: 12px;
    font-weight: 300;
    color: #828282;
    line-height: 1.5;
    .actived {
      color: #1e9755;

      label {
        font-weight: 600;
      }
    }
  }
}

.qrcode__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.q-field--filled .q-field__control:before {
  border-bottom: none;
}

.q-field--filled.q-field--readonly .q-field__control:before {
  border-bottom-style: none;
}
</style>
